import React from 'react';
import { Heart, Sparkles, Leaf as LeafIcon, Users, ArrowRight } from 'lucide-react';
import { values } from '../../mock/data';
import { Cloud, Squirrel, Leaf, Bird } from './Decor';

const iconMap = { Heart, Sparkles, Leaf: LeafIcon, Users };

const About = () => {
  return (
    <section id="tentang" className="relative overflow-hidden pt-20 pb-32" style={{ background: '#ffffff' }}>
      {/* Decorations */}
      <div className="absolute inset-0 pointer-events-none">
        <Cloud size={180} className="absolute top-6 left-6 opacity-70" tone="#e6f2f8" />
        <Cloud size={220} className="absolute top-16 right-6 opacity-70" tone="#e6f2f8" />
        <Leaf size={70} className="absolute top-[30%] left-[4%] animate-float" />
        <Leaf size={54} className="absolute top-[46%] right-[3%] animate-float" color="#a8d97e" />
        <div className="absolute bottom-16 right-[6%] animate-float"><Squirrel size={110} /></div>
        <div className="absolute bottom-24 left-[4%] animate-float" style={{ animationDelay: '0.8s' }}>
          <Squirrel size={90} flip />
        </div>
        <div className="absolute top-[42%] right-[24%] animate-bird"><Bird size={54} /></div>
      </div>

      <div className="relative max-w-[1200px] mx-auto px-6 lg:px-10">
        <div className="text-center max-w-[820px] mx-auto">
          <div className="font-hand text-[15px] tracking-[0.35em] text-[#3aa9b7] mb-2">TENTANG KAMI</div>
          <h2 className="font-brush text-[46px] md:text-[64px] leading-[1] text-[#c74a2a]">
            Rumah Ceria untuk Anak Bertumbuh
          </h2>
          <p className="mt-6 font-hand text-[18px] md:text-[20px] text-[#4a3b2a]/85 leading-relaxed">
            TK Melati Asri adalah taman kanak-kanak yang percaya bahwa setiap anak adalah
            <span className="text-[#c74a2a] font-semibold"> bunga yang unik</span>. Kami merawatnya dengan
            kasih sayang, permainan, dan pengalaman belajar yang menyenangkan agar mereka tumbuh
            <span className="text-[#3aa9b7] font-semibold"> percaya diri, kreatif, dan berkarakter</span>.
          </p>

          <button
            onClick={() => document.getElementById('program')?.scrollIntoView({ behavior: 'smooth' })}
            className="mt-8 inline-flex items-center gap-3 px-8 py-4 rounded-full bg-[#3aa9b7] text-white font-hand text-[17px] shadow-[0_6px_0_#256d78] hover:translate-y-[2px] hover:shadow-[0_4px_0_#256d78] transition-all"
          >
            Kenali Program Kami <ArrowRight size={18} />
          </button>
        </div>

        {/* Values grid */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((v, idx) => {
            const Icon = iconMap[v.icon];
            const bgs = ['#fff2e2', '#e7f4fa', '#eaf6e2', '#ffe8dd'];
            const iconColors = ['#ee7a3d', '#3aa9b7', '#6fae4a', '#e08557'];
            return (
              <div
                key={v.title}
                className="group relative bg-white rounded-[28px] p-7 border-2 border-[#f1e6d2] hover:border-[#ee7a3d] hover:-translate-y-2 transition-all duration-300 shadow-[0_6px_0_rgba(200,170,120,0.35)]"
                style={{ animationDelay: `${idx * 0.08}s` }}
              >
                <div
                  className="w-16 h-16 rounded-2xl flex items-center justify-center mb-4 rotate-[-6deg] group-hover:rotate-[6deg] transition-transform duration-500"
                  style={{ background: bgs[idx % bgs.length] }}
                >
                  {Icon && <Icon size={30} color={iconColors[idx % iconColors.length]} />}
                </div>
                <h3 className="font-brush text-[26px] text-[#2b8b98]">{v.title}</h3>
                <p className="mt-2 font-hand text-[16px] text-[#4a3b2a]/80 leading-snug">{v.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;
